import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  dialogPaper: {
    '&.MuiDialog-paper': {
      borderRadius: 0,
    },
  },
  dialogTitle: {
    '&.MuiDialogTitle-root': {
      paddingBottom: 0,
      textAlign: 'center',
    },
  },
  dialogContent: {
    '&.MuiDialogContent-root': {
      paddingTop: 12,
      paddingBottom: 8,
    },
  },
  dialogActions: {
    '&.MuiDialogActions-root': {
      padding: 16,
    },
  },
  formControl: {
    '&.MuiFormControl-root': {
      marginTop: 16,
      marginBottom: 8,
    },
  },
  fieldLabel: {
    marginBottom: 8,
    fontWeight: 500,
  },
  readOnlyEdition: {
    marginTop: 24,
    padding: '8px 0',
    fontWeight: 500,
  },
}));

export default useStyles;
